const {
  subDays,
  subWeeks,
  format,
} = require('date-fns');
const set = require('lodash.set');

const mapOperator = (operator, apollo = false) => {
  switch (operator) {
    case 'Not equal':
      return 'ne';
    case 'Less than':
      return 'lt';
    case 'Less than or equal to':
      return 'lte';
    case 'Greater than':
      return 'gt';
    case 'Greater than or equal to':
      return 'gte';
    case 'Included in an array':
      return 'in';
    case 'Not included in an array':
      return apollo ? 'notIn' : 'nin';
    case 'Contains':
      return apollo ? 'contains' : 'glob';
    // case 'Does not contain':
    //   return apollo ? 'notContains' : null;
    case 'Is null':
      return apollo ? 'null' : null; // gatsby should never come here
    case 'Is not null':
      return apollo ? 'notNull' : null; // gatsby should never come here
    // 'Starts with',
    // 'Ends with',
    case 'Equal':
      return 'eq';
    default:
      throw new Error(`Unknown operator in mapOperator: ${operator}`);
  }
};

const mapValue = (value, operator, Constructor = String) => {
  if (['in', 'notIn', 'nin'].includes(operator)) {
    return value.split(',').map((str) => Constructor(str.trim()));
  }
  if (operator === 'glob') {
    return `*${value}*`;
  }
  if (value === 'false') {
    return false;
  }
  if (value === 'true') {
    return true;
  }
  if (value.startsWith('subWeeks:')) {
    const substract = value.replace('subWeeks:', '').trim();
    const substracted = subWeeks(new Date(), substract);
    return format(substracted, 'yyyy-MM-dd');
  }
  if (value.startsWith('subDays:')) {
    const substract = value.replace('subDays:', '').trim();
    const substracted = subDays(new Date(), substract);
    return format(substracted, 'yyyy-MM-dd');
  }
  return Constructor(value);
};

const mapApolloKey = (operator, key) => {
  switch (operator) {
    case 'ne':
    case 'nin':
      return `${key}_not`;
    case 'null':
      return `${key}_null`;
    case 'notNull':
      return `${key}_notNull`;
    case 'gt':
    case 'gte':
      return `${key}Min`;
    case 'lt':
    case 'lte':
      return `${key}Max`;
    default:
      return key;
  }
};

const gatsby = (refinementComponents) => (refinementComponents || []).reduce((acc, component) => {
  if (!component.field) {
    // incomplete refinement
    return acc;
  }
  if (component.operator === 'Is not null') {
    return set(acc, `${component.field}.${component.value === 'false' ? 'eq' : 'ne'}`, null);
  }
  if (component.operator === 'Is null') {
    return set(acc, `${component.field}.${component.value === 'false' ? 'ne' : 'eq'}`, null);
  }

  const operator = mapOperator(component.operator);
  // clientId is now a String as well, gatsby couldn't eq a number like 49254
  const Constructor = [].includes(component.field) ? String : String;
  const value = mapValue(component.value, operator, Constructor);

  return set(acc, `${component.field}.${operator}`, value);
}, {});

const apollo = (refinementComponents) => (refinementComponents || []).reduce((acc, component) => {
  if (!component.field) {
    // incomplete refinement
    return acc;
  }
  const operator = mapOperator(component.operator, true);
  const value = mapValue(component.value, operator);

  return {
    ...acc,
    [mapApolloKey(operator, component.field)]: value,
  };
}, {});

module.exports = {
  gatsby,
  apollo,
};
